import axios from "axios";

export function loginUser(payload) {
	return axios.post(`${process.env.REACT_APP_DANSUAPI}/public/prestador/login`, {	
		cuil_cuit: payload.user,
		password: payload.password,
	});
}